module.exports = __webpack_public_path__ + "static/media/7de67c3d-c725-4973-9896-fe6437f09095_1.e36b7c5d0093360019450be7ad7f5f73.2bb96a9f.jpeg";